import UiListItem from "./UiListItem";
import MiezzListItem from "@/models/MiezzListItem";
import { EnumPipe } from "@/models/EnumPipe";
import DtoListItemTradeTerms_TransactionMode from "./DtoListItemTradeTerms_TransactionMode";
import { EnumParamAuditStatus, EnumParamAuditStatusOption } from "./EnumParamAuditStatus";

/**
 * 贸易条款分页列表-项
 * @description 自动生成的代码,请勿修改
 */
export default class DtoListItemTradeTerms extends UiListItem<string> {
    constructor() {
        //无参构造函数
        super()
        this.Status = EnumParamAuditStatus.Not;
        this.IsEdit = false;
    }

    [proName: string]: any;
    /**
     * 中文名称
     */
    Name?: string;
    /**
     * 英文名称
     */
    NameEn?: string;
    /**
     * 英文简写
     */
    Code?: string;
    /**
     * 全名
     */
    FullName?: string;
    /**
     * 对应的成交方式
     */
    TransactionMode?: DtoListItemTradeTerms_TransactionMode;
    /**
     * 审核状态
     */
    Status?: EnumParamAuditStatus;
    /**
     * 是否可以编辑
     */
    IsEdit?: boolean;
    /**
     * 创建人所属公司
     */
    CreatedCompanyId?: string;
}

/**
 * 贸易条款分页列表-项-表单校验
 */
export const DtoListItemTradeTermsRules = {
}

/**
 * 贸易条款分页列表-项-设置项
 */
export const DtoListItemTradeTermsMiezzListItems: MiezzListItem[]  = [
  {
    Prop: "Name",
    Label: "中文名称",
  },
  {
    Prop: "NameEn",
    Label: "英文名称",
  },
  {
    Prop: "Code",
    Label: "英文简写",
  },
  {
    Prop: "FullName",
    Label: "全名",
  },
  {
    Prop: "TransactionMode",
    Label: "对应的成交方式",
    Customize: true,
  },
]
